<template>
  <div class="product73new">
    <div class="body">
      <div style="text-align: center;">
        <img src="@/assets/images/product/73/new/01.png" alt="" />
      </div>

      <ul class="tabs">
        <li
          v-for="(item, index) in tabs"
          :key="index"
          @click="handleClickTabs(index)"
          :class="tabsIndex == index ? 'checkedClass' : ''"
        >
          {{ item }}
        </li>
      </ul>

      <div style="text-align: center; margin-top: 50px;" ref="tabs1">
        <img src="@/assets/images/product/73/new/02.png" alt="" />
      </div>

      <ul class="tabs2">
        <li
          v-for="(item, index) in tabs2"
          :key="index"
          @click="tabsIndex2 = index"
          :style="index == tabsIndex2 ? 'background:#177df1;color:#fffa75' : ''"
        >
          <span class="title">{{ item.title }}</span>
          <span class="desc">{{ item.desc }}</span>
        </li>
      </ul>

      <div
        style="text-align: center;position: relative;"
        @mouseenter="pauseSlideshow"
        @mouseleave="resumeSlideshow"
      >
        <div v-show="tabsIndex2 == 0">
          <img src="@/assets/images/product/73/new/03.jpg" alt="" />
        </div>

        <div v-show="tabsIndex2 == 1">
          <img src="@/assets/images/product/73/new/04.jpg" alt="" />
        </div>

        <div v-show="tabsIndex2 == 2">
          <img src="@/assets/images/product/73/new/05.jpg" alt="" />
        </div>

        <div v-show="tabsIndex2 == 3">
          <img src="@/assets/images/product/73/new/06.jpg" alt="" />
        </div>

        <img
          src="@/assets/images/product/73/new/btn.png"
          alt=""
          class="btn"
          @click="goBuy()"
        />
      </div>

      <div style="text-align: center; margin-top: 50px;" ref="tabs2">
        <img src="@/assets/images/product/73/new/07.png" alt="" />
      </div>

      <ul class="tabs2">
        <li
          v-for="(item, index) in tabs3"
          :key="index"
          @click="tabsIndex3 = index"
          :style="index == tabsIndex3 ? 'background:#177df1;color:#fffa75' : ''"
        >
          <span class="title">{{ item.title }}</span>
          <span class="desc">{{ item.desc }}</span>
        </li>
      </ul>

      <div style="text-align: center;position: relative;">
        <div v-show="tabsIndex3 == 0">
          <img src="@/assets/images/product/73/new/08.jpg" alt="" />
        </div>

        <div v-show="tabsIndex3 == 1">
          <img src="@/assets/images/product/73/new/09.jpg" alt="" />
        </div>

        <img
          src="@/assets/images/product/73/new/btn.png"
          alt=""
          class="btn"
          @click="goBuy()"
        />
      </div>

      <div style="text-align: center; margin-top: 50px;" ref="tabs3">
        <img src="@/assets/images/product/73/new/10.png" alt="" />
      </div>

      <ul class="tabs2">
        <li
          v-for="(item, index) in tabs4"
          :key="index"
          @click="tabsIndex4 = index"
          :style="index == tabsIndex4 ? 'background:#177df1;color:#fffa75' : ''"
        >
          <span class="title">{{ item.title }}</span>
          <span class="desc">{{ item.desc }}</span>
        </li>
      </ul>

      <div style="text-align: center;position: relative;">
        <div v-show="tabsIndex4 == 0">
          <img src="@/assets/images/product/73/new/11.jpg" alt="" />
        </div>

        <img
          src="@/assets/images/product/73/new/btn.png"
          alt=""
          class="btn"
          @click="goBuy()"
        />
      </div>

      <div style="text-align: center; margin-top: 50px;" ref="tabs4">
        <img src="@/assets/images/product/73/new/12.png" alt="" />
      </div>

      <div style="text-align: center;position: relative;">
        <div>
          <img src="@/assets/images/product/73/new/13.jpg" alt="" />
        </div>

        <img
          src="@/assets/images/product/73/new/btn.png"
          alt=""
          class="btn"
          @click="goBuy()"
        />
      </div>

      <div style="text-align: center; margin-top: 50px;" ref="tabs5">
        <img src="@/assets/images/product/73/new/14.png" alt="" />
      </div>

      <div style="text-align: center;position: relative;">
        <div>
          <img src="@/assets/images/product/73/new/15.jpg" alt="" />
        </div>

        <img
          src="@/assets/images/product/73/new/btn.png"
          alt=""
          class="btn"
          @click="goBuy()"
        />
      </div>

      <div style="padding-bottom: 50px;"></div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      id: this.$parent.id,
      month : 12,
      tabsIndex: 0,
      tabsIndex2: 0,
      tabsIndex3: 0,
      tabsIndex4: 0,
      tabs: ["股票池", "大单洞察", "机构追踪", "专业数据", "特色指标"],
      tabs2: [
        {
          title: "自设股票池",
          desc: "投资者专属的“超级研究员团队"
        },
        {
          title: "尾盘选股模型",
          desc: "1号系统股票池"
        },
        {
          title: "竞价优选模型",
          desc: "2号系统股票池"
        },
        {
          title: "DDE资金潜伏模型",
          desc: "3号系统股票池"
        }
      ],
      tabs3: [
        {
          title: "智能复盘统计",
          desc: "复盘大师的“顶级装备”"
        },
        {
          title: "超赢实时监控",
          desc: "“超大户”资金动向一目了然"
        }
      ],
      tabs4: [
        {
          title: "机构去哪儿",
          desc: "跟着机构去调研，快人一步！"
        }
      ],
      interval: null
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.startSlideshow();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    goBuy () {
      this.$router.push("/order/confirm/73/12?s=official");
    },
    nextTab() {
      this.tabsIndex2 = (this.tabsIndex2 + 1) % 4; // 0-3循环
    },
    pauseSlideshow() {
      clearInterval(this.interval);
    },
    resumeSlideshow() {
      this.startSlideshow();
    },
    startSlideshow() {
      this.interval = setInterval(this.nextTab, 5000); // 每5秒切换
    },
    handleClickTabs: function(index) {
      this.tabsIndex = index;

      if (index == 0) {
        // 通过 ref 获取对应的目标元素并滚动到该元素
        const section = this.$refs.tabs1;
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      } else if (index == 1) {
        // 通过 ref 获取对应的目标元素并滚动到该元素
        const section = this.$refs.tabs2;
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      } else if (index == 2) {
        // 通过 ref 获取对应的目标元素并滚动到该元素
        const section = this.$refs.tabs3;
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      } else if (index == 3) {
        // 通过 ref 获取对应的目标元素并滚动到该元素
        const section = this.$refs.tabs4;
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      } else if (index == 4) {
        // 通过 ref 获取对应的目标元素并滚动到该元素
        const section = this.$refs.tabs5;
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.product73new {
  background: #00113a url("../../assets/images/product/73/new/bg.jpg")
    no-repeat center top;
  color: #fff;

  .body {
    width: 900px;
    margin: 0 auto;
    .btn {
      position: absolute;
      width: 245px;
      height: 68px;
      left: 50%;
      margin-left: calc(-245px / 2);
      bottom: 20px;
      cursor: pointer;
    }
    .tabs {
      display: flex;
      align-items: center;
      justify-content: space-around;
      position: sticky;
      top: 10px;
      z-index: 9;
      li {
        font-size: 24px;
        cursor: pointer;
        width: 150px;
        height: 54px;
        text-align: center;
        line-height: 54px;
        flex-shrink: 0;
        background: url("../../assets/images/product/73/new/btn_bg_1.png")
          no-repeat;
        background-size: 100% 100%;
      }
      .checkedClass {
        background: url("../../assets/images/product/73/new/btn_bg_2.png")
          no-repeat;
        background-size: 100% 100%;
      }
    }

    .tabs2 {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 440px;
        height: 50px;
        line-height: 50px;
        background: #043d88;
        border: 1px solid #1078fa;
        padding: 0 15px;
        flex-shrink: 0;
        margin-top: 15px;
        cursor: pointer;
        .title {
          font-size: 24px;
        }

        .desc {
          font-size: 20px;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/Product73new.vue